import { getTempInfo, getToastConfPoint } from '../common.js';
import { Toast } from 'antd-mobile/lib';
import Util from '../util.js'
import {validateTransactionPassword} from './investmentAction.js'
import { getCwimUserHqtCard } from './myAssets/userInfoAction';

//基金历史净值
export function fundHistoryRatePage(text){
  return {
    type:"FUND_HISTORY_RATE_PAGE",
    text:text
  }
}

//更改银行活期通位置
export function choseBankIndex(text){
  return {
    type:"SELECTED_BANK_INDEX",
    text:text
  }
}
export function choseCurrentIndex(text){
  return {
    type:"SELECTED_CURRENT_INDEX",
    text:text
  }
}
export function choseBankOrCurrent(text){
  return {
    type:"BANK_OR_CURRENT",
    text:text
  }
}
export function changeCurrentIndex(text){
  return {
    type:"CURRENT_INDEX",
    text:text
  }
}
export function changeCurrentType(text){
  return {
    type:"CURRENT_TYPE",
    text:text
  }
}
export function choseCurrencyIndex(text){
  return {
    type:"CURRENCY_INDEX",
    text:text
  }
}
export function choseTargetIndex(text){
  return {
    type:"TARGET_INDEX",
    text:text
  }
}
//支付
export function payInfo(text){
  return {
    type:"PAY_INFO",
    text:text
  }
}
export function currentAccount(text){
  return {
    type:"CURRENT_ACCOUNT",
    text:text
  }
}
export function productInfo(text){
  return {
    type:"PRODUCT_INFO",
    text:text
  }
}
//产品类型
export function productListType(text){
  return {
    type:"PRODUCT_LIST_TYPE",
    text:text
  }
}
//合同
export function getContract(fundCode,callback) {
  return function(dispatch, getState) {
    // dispatch(pageFlag(true))
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,
        fundCode:fundCode,
      }
      Util.get(Util.url+"/api/trade/getContract",data,function(result){
        if (result.code=='0000') {
          callback(result)
        } else {
          Toast.info(result.message, Util.ToastTime );
        }
        console.log(result)
      },function(error){
        console.log('合同 error')
      })
        
    }).catch( (err)=>{ 
      // dispatch(pageFlag(false))
    } )
  }
}
export function getProductInfo(){
  return function(dispatch, getState){
    let homePage=window.sessionStorage.getItem('homePage');
    if (homePage) {
      dispatch(productInfo(JSON.parse(homePage)));
    }else{
      Toast.loading('', 0);
    }
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d
      }
      Util.get(Util.url+"/api/cms/getHomePage",data,function(result){
        Toast.hide()
        if (result.code=='0000') {
          window.sessionStorage.setItem('homePage',JSON.stringify(result.content));
          dispatch(productInfo(result.content));
        }else{
          Toast.info( Util.errorTxt, Util.ToastTime );
        }
      },function(error){
        Toast.info( Util.errorTxt, Util.ToastTime );
      })
    }).catch( (err)=>{Toast.info( Util.errorTxt, Util.ToastTime ); } )
  }
}
//活期通充值
const bankList = (data)=>{
  return new Promise((resolve,reject)=>{
      Util.get(Util.url+"/api/trade/getCamcBankCardList",data,function(result){
        if (result.code=='0000') {
          resolve(result)
        } else{
          reject('1111')
        }
      },function(error){
          reject('1111')
        // let toast = Toast.show( Util.errorTxt, getToastConfPoint( ) );
      });
  })
}
export  const fundInfo = (data)=>{
  return new Promise((resolve,reject)=>{
      Util.get(Util.url+"/api/myAsset/getFundInfo",{fundcode:data.fundCode},function(result){
          resolve(result)
      },function(error){
          reject('1111')
      })
  })
}
const minAmount = (data)=>{
  return new Promise((resolve,reject)=>{
      Util.get(Util.url+"/superfund/buy/getLimitAmount",{fundCode:data.fundCode,tradeType:data.businessType,token:data.token},function(result){
          resolve(result)
      },function(error){
          reject('1111')
      })
  })
}
export function getCamcBankCardList(fundCode,businessType,bankAccountShowNo,callback){
  return  function(dispatch, getState){
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,fundCode:fundCode,businessType:businessType,clientType:Util.return_Clinet_Type()
      }
      const p = Promise.all([bankList(data), fundInfo(data),minAmount(data)]);
      p.then(response => {
        console.log(response);
        var obj={code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[],currentNav:'',currentNavDate:'',fundCode:'',fundName:'',minAmount:''}}
        obj.content.fundName=response[1].content.fund_name;
        obj.content.fundCode=response[1].content.fund_code;
        obj.content.currentNavDate=response[1].content.publish_date;
        obj.content.currentNav=response[1].content.wanfenshouyi;
        obj.content.minAmount=response[2].content
        let num=0
        let arr=[]
        response[0].content.forEach((item,index)=>{
          if (bankAccountShowNo==item.bankAccountShowNo) {
            num=index;
          };
          var amountTip=parseInt(item.tradeMaxAmountTips)
          if(amountTip - 0 == amountTip) {
            if (amountTip>=10000) {
              var str2='单笔'+amountTip/10000+'万单日'+amountTip/10000+'万'
            }else{
              var str2='单笔'+amountTip.toFixed(0)+'单日'+amountTip.toFixed(0)
            }
          }else {
            if(item.paymentChannel == "G000" && item.ywt == false) {
              var str2='招行卡暂不可用，请您去华夏基金管家App操作或咨询客服'
            }else {
              var str2='具体支付限额请咨询客服'
            }
          }
          let str=amountTip.toFixed(0)+'|'+str2
          Object.assign(item,{disable:true,tradeMaxAmountTips:str})
          arr.push(item)
        })
        obj.content.currentAccountList=arr;
        obj.currentType=1;
        obj.currentIndex=num;
        callback(obj)
        Toast.hide()
      }).catch(error => {
        Toast.info( Util.errorTxt, Util.ToastTime )
      });
      
    } ) .catch( (err)=>{ console.log(err) } )
  }
}
export function validateHqtPay(data,callback=()=>{}){
  return function(dispatch, getState){
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();
      dispatch(validateTransactionPassword(data,(c)=>{
         if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;} 
         Util.post(Util.url+"/api/trade/validateHqtPay",data,function(result){
            if (result.code=='0000') {
              dispatch(submitHqtPay(data,callback))
            } else {
              if (result.message=='未做风险问卷或风险评级已过期') {
                callback(3,'抱歉，您在华夏基金的风险调查问卷已过期，请先登录华夏基金官网或管家APP完成风险问卷，谢谢');
              }else{
                
                Toast.info(result.message, Util.ToastTime )
              }
            }
          },function(error){
            
            Toast.info( Util.errorTxt, Util.ToastTime );
          })
      },(m)=>{
          
          Toast.info( Util.errorTxt, Util.ToastTime );
      }))
    } ) .catch( (err)=>{ Toast.info( Util.errorTxt, Util.ToastTime ); } )
  }
}
//货币基金购买其他基金
export function submitHqtPay(data,callback=()=>{}){
  return function(dispatch, getState){
    Util.post(Util.url+"/api/trade/submitHqtPay",data,function(result){
      if (result.code=='0000') {
        callback(1,result);
      } else {
        callback(3,result.message);
      }
    })
  }
}
//支付1
export function getPayInfo(fundCode,businessType,productType,callback=()=>{}){
  return function(dispatch, getState){
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,fundCode:fundCode,businessType:businessType,productType:productType
      }
      // console.log(Util.url+"/api/trade/getTradeInfo",data)
      // Util.get(Util.url+"/api/trade/getTradeInfo",data,function(result){
        console.log(Util.url+"/api/asset/getCamcHqtPayList",data)
      Util.get(Util.url+"/api/v1/payment/getHqtAndBankCardList",data,function(result){
        if (result.code=='0000') {
          dispatch(payInfo(result));
          if (result.content.shareList.length>0) {
            if (!getState().bankOrCurrent) {
              dispatch(choseBankOrCurrent(false));
            }
          } else {
              dispatch(choseBankOrCurrent(true));
          }
          Toast.hide()
        }else{
          Toast.info(result.code, Util.ToastTime );
        }
        console.log(result,'接口payInfo',data)
      },function(error){
        Toast.info( Util.errorTxt, Util.ToastTime );
      });

    } ) .catch( (err)=>{ Toast.info( Util.errorTxt, Util.ToastTime ) } )
  }
}
export function getTradeInfo(fundCode,businessType,productType,callback){
  return function(dispatch, getState){
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,fundCode:fundCode,businessType:businessType,productType:productType
      }
      // Util.get(Util.url+"/api/trade/getTradeInfo",data,function(result){
        Util.get(Util.url+"/api/v1/payment/getHqtAndBankCardList",data,function(result){
        if (result.code=='0000') {
          Util.get(Util.url+"/api/trade/getMonetaryFundPayList",{token:d},async function(data){
            result.content.currencyFund=[];//初始化数据格式
            let type=1;//1银行卡 2活期通 3货币基金
            let num=0;//默认选中卫视
            if (data.code='0000') {
              
              // let hqtList = await getCwimUserHqtCard({ token:d})
              // console.log(hqtList);
              
              // for (let i = 0; i < result.content.shareList.length; i++) {
              //   for (let j =0; j < hqtList.length ;j++) {
              //     if(result.content.shareList[i].paymentChannel == "888" && hqtList[j].trustChannelId == "888") {
              //       if(result.content.shareList[i].bankCode == hqtList[j].bankCode && result.content.shareList[i].bankAccountShowNo != hqtList[j].bankAccountShowNo) {
              //         result.content.shareList[i].bankAccountShowNo2 = hqtList[j].bankAccountShowNo;
              //         if(result.content.shareList[i].bankCode != "007") {
              //           result.content.shareList[i].enableCMBTrustChannel = "0";
              //         }
              //       }
              //     }else {
              //       if(hqtList[j].trustChannelId != "888") {
              //         if(result.content.shareList[i].bankCode == hqtList[j].bankCode && result.content.shareList[i].bankAccountShowNo != hqtList[j].bankAccountShowNo) {
              //           result.content.shareList[i].bankAccountShowNo2 = hqtList[j].bankAccountShowNo;
              //           if(result.content.shareList[i].bankCode != "007") {
              //             result.content.shareList[i].enableCMBTrustChannel = "0";
              //           }
              //         }
              //       }
              //     }
              //   }  
              // }

              data.content.forEach((value, index, array) =>{
                value.trustChannelShares.forEach((shares, index, array) =>{
                  let obj= Object.assign(JSON.parse(JSON.stringify(value)),JSON.parse(JSON.stringify(shares)))
                  result.content.currencyFund.push(obj);
                })
              });//货币基金数据
              result.content.currencyFund.sort(getVal('availableVolume'));
              result.content.shareList.sort(getVal('availableVolume'));
              //排序 G000放在最后
              let newShareRight=[];
              let newShareLeft=[];
              result.content.shareList.forEach(e=>{
                if(e.paymentChannel=='G000' && e.ywt == true) {
                  newShareLeft.push(Object.assign(e,{disable:true}))
                }else if(e.paymentChannel=='G000' && e.ywt == false) {
                  newShareRight.push(Object.assign(e,{disable:false}))
                }else {
                  if ((e.paymentChannel=='G000' && !e.enableCMBTrustChannel) || e.enableCMBTrustChannel == "0") {
                    newShareRight.push(Object.assign(e,{disable:false}))
                  }else{
                    newShareLeft.push(Object.assign(e,{disable:true}))
                  }
                }
              })
              
              //屏蔽 超级基金购买、定投和普通定投
              let newShareRight2=[];
              let newShareLeft2=[];
              result.content.currentAccountList.forEach(e=>{
                if (businessType=='T522'||businessType=='T039') {
                  if (e.paymentChannel != "888") {
                    if (e.tradeMaxAmountTips) {
                      if (e.tradeMaxAmountTips.indexOf('暂不支持该行扣款')==-1) {
                        newShareLeft2.push(Object.assign(e,{disable:true}))
                      }else{
                        newShareRight2.push(Object.assign(e,{disable:false}))
                      }
                    }else{
                      newShareLeft2.push(Object.assign(e,{disable:true}))
                    }
                  }
                }else{
                  if (e.tradeMaxAmountTips) {
                    if (e.tradeMaxAmountTips.indexOf('暂不支持该行扣款')==-1) {
                      newShareLeft2.push(Object.assign(e,{disable:true}))
                    }else{
                      newShareRight2.push(Object.assign(e,{disable:false}))
                    }
                  }else{
                    newShareLeft2.push(Object.assign(e,{disable:true}))
                  }
                }
              })
              result.content.currentAccountList=[...newShareLeft2,...newShareRight2]
              result.content.shareList=[...newShareLeft,...newShareRight]
              if (result.content.currencyFund.length>0&&result.content.shareList.length>0) {
                if(result.content.shareList[0].paymentChannel == "G000" && result.content.shareList[0].ywt == true) {
                  if (result.content.currencyFund[0].availableVolume-0>result.content.shareList[0].availableVolume-0) {
                    type=3
                  }else{
                    type=2
                  }
                }else if(result.content.shareList[0].paymentChannel == "G000" && result.content.shareList[0].ywt == false) {
                  type=3
                }else {
                  if ((result.content.shareList.length==1&&result.content.shareList[0].paymentChannel == "G000"&&!result.content.shareList[0].enableCMBTrustChannel) || (result.content.shareList.length==1&&result.content.shareList[0].enableCMBTrustChannel=="0")) {
                    type=3
                  } else {
                    if (result.content.currencyFund[0].availableVolume-0>result.content.shareList[0].availableVolume-0) {
                      type=3
                    }else{
                      type=2
                    }
                  }
                }
              }else if(result.content.shareList.length>0) {
                if(result.content.shareList[0].paymentChannel == "G000" && result.content.shareList[0].ywt == true) {
                  type=2
                }else if(result.content.shareList[0].paymentChannel == "G000" && result.content.shareList[0].ywt == false) {
                  type=1
                }else {
                  if ((result.content.shareList.length==1&&result.content.shareList[0].paymentChannel == "G000"&&!result.content.shareList[0].enableCMBTrustChannel) || (result.content.shareList.length==1&&result.content.shareList[0].enableCMBTrustChannel=="0")) {
                    type=1
                  } else {
                    type=2
                  }
                }
              }else if(result.content.currencyFund.length>0){
                type=3
              }else{
                type=1
              }
              // dispatch(payInfo(result));
              // if (getState().currentType==4){
              //   dispatch(changeCurrentType(type))
              //   dispatch(changeCurrentIndex(num))
              // }
              let arrlist=[]
              let arrlists=[]
              let newList =[]
              if(result.content.currentAccountList){
                arrlist =  result.content.currentAccountList.map(item=>{
                  return {
                    ...item,
                    yhkBool:false
                  }
                })
              }
              if(result.content.camcBankCards){
                arrlists =  result.content.camcBankCards.map(item=>{
                  return {
                    ...item,
                    yhkBool:true,
                    disable:true
                  }
                })
              }
              newList=[...arrlist,...arrlists]
              result.content.yhkNewListList=newList//财富银行卡和直销银行卡
              callback(result,num,type)
              Toast.hide()
            }
          },function(error){
            Toast.info( Util.errorTxt, Util.ToastTime );
          });
        }
      },function(error){
        Toast.info( Util.errorTxt, Util.ToastTime );
      });
    } ) .catch( (err)=>{ Toast.info( Util.errorTxt, Util.ToastTime ) } )
  }
}
export function getTradeInfo2(fundCode,businessType,productType){
  return function(dispatch, getState){
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,fundCode:fundCode,businessType:businessType,productType:productType
      }
      // Util.get(Util.url+"/api/trade/getTradeInfo",data,function(result){
        Util.get(Util.url+"/api/v1/payment/getHqtAndBankCardList",data,function(result){
        if (result.code=='0000') {
          result.content.currencyFund=[];
          let type=1;
          let num=0;
          result.content.shareList.sort(getVal('availableVolume'));
          let newShareRight=[];
          let newShareLeft=[];
          result.content.shareList.forEach(e=>{
            console.log(e)
            if(e.paymentChannel=='G000' && e.ywt == true) {
              newShareLeft.push(Object.assign(e,{disable:true}))
            }else if(e.paymentChannel=='G000' && e.ywt == false) {
              newShareRight.push(Object.assign(e,{disable:false}))
            }else {
              if ((e.paymentChannel=='G000' && !e.enableCMBTrustChannel) || e.enableCMBTrustChannel == "0") {
                newShareRight.push(Object.assign(e,{disable:false}))
              }else{
                newShareLeft.push(Object.assign(e,{disable:true}))
              }
            }
          })
          let newShareRight2=[];
          let newShareLeft2=[];
          result.content.currentAccountList.forEach(e=>{
            if (businessType=='T522'||businessType=='T039') {
              if (e.paymentChannel != "888") {
                if (e.tradeMaxAmountTips) {
                  if (e.tradeMaxAmountTips.indexOf('暂不支持该行扣款')==-1) {
                    newShareLeft2.push(Object.assign(e,{disable:true}))
                  }else{
                    newShareRight2.push(Object.assign(e,{disable:false}))
                  }
                }else{
                  newShareLeft2.push(Object.assign(e,{disable:true}))
                }
              }
            }else{
              if (e.tradeMaxAmountTips) {
                if (e.tradeMaxAmountTips.indexOf('暂不支持该行扣款')==-1) {
                  newShareLeft2.push(Object.assign(e,{disable:true}))
                }else{
                  newShareRight2.push(Object.assign(e,{disable:false}))
                }
              }else{
                newShareLeft2.push(Object.assign(e,{disable:true}))
              }
            }
          })
          result.content.currentAccountList=[...newShareLeft2,...newShareRight2]
          result.content.shareList=[...newShareLeft,...newShareRight]
          // if (result.content.shareList.length>0) {
          //   if (result.content.shareList.length==1&&result.content.shareList[0].paymentChannel == "G000" &&!result.content.shareList[0].enableCMBTrustChannel) {
          //     type=1
          //   } else {
          //     type=2
          //   }
          // } else {
          //   type=1

          // }
          // dispatch(changeCurrentType(type))
          // dispatch(changeCurrentIndex(num))
          dispatch(payInfo(result));
          Toast.hide()
        }else{
          Toast.info(result.code, Util.ToastTime );
        }
      },function(error){
        Toast.info( Util.errorTxt, Util.ToastTime );
      });

    } ) .catch( (err)=>{ Toast.info( Util.errorTxt, Util.ToastTime ) } )
  }
}
//排序函数
let getVal=(property)=>{
    return function(a,b){
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
    }
};
//支付渠道
export function getPayAccount(fundCode,businessType){
  return function(dispatch, getState){
    Toast.loading('', 0, () => {});
     getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,fundCode:fundCode,businessType:businessType
      }
      Util.get(Util.url+"/api/trade/getCurrentAccount",data,function(result){
        result.content.shareList.sort(getVal('availableVolume'));
        result.content.minAmount=0;
        result.content.currentNav='';
        result.content.currentNavDate='';
        result.content.fundCode='';
        result.content.fundName='';
        if (businessType=='T522') {
          let oldArr=result.content.currentAccountList;
          let newArr = oldArr.filter(function(item){
            return item.paymentChannel != "888";
          });
          result.content.currentAccountList=newArr;
        }
        dispatch(payInfo(result));
        Toast.hide()
        if (result.content.shareList.length>0) {
          if (!getState().bankOrCurrent) {
            dispatch(choseBankOrCurrent(false));
          }
        } else {
            dispatch(choseBankOrCurrent(true));
        }
        console.log(result,'getPayAccount',data)
      },function(error){
        Toast.hide()
        Toast.info( Util.errorTxt, Util.ToastTime );
      });

    } ) .catch( (err)=>{ console.log(err) } )
  }
}
//最低投资金额
export function getLimitAmount(data,callBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/superfund/buy/getLimitAmount",data,function(result){
        if (result.code=='0000') {
          callBack(result.content)
        }else{
          Toast.info(result.message, Util.ToastTime );
        }
      },function(error){
        Toast.info( Util.errorTxt, Util.ToastTime );
        console.log('费用计算入参 error')
      })
    }).catch( (err)=>{ console.log(err) } )
  }
}
//交易
export function getTransaction(data,callback=()=>{}){
  return function(dispatch, getState){
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();
      dispatch(validateTransactionPassword(data,(c)=>{
         if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;}
         Util.post(Util.url+"/api/trade/doBuyRequest",data,function(result){
          if (result.code=='0000') {
            Toast.hide()
            callback(1,result);
          } else {
            callback(3);
            Toast.hide()
            Toast.info(result.message, Util.ToastTime );
          }
        },function(error){
          callback(3);
          Toast.hide()
          Toast.info(Util.errorTxt, Util.ToastTime );
        })
      },(m)=>{
          callback(3);
          Toast.hide()
          Toast.info(m, Util.ToastTime );
      }))
    } ) .catch( (err)=>{ Toast.hide()} )
  }
}
//货币基金购买其他基金校验
export function monetaryFundBuyValidate(data,callback=()=>{}){
  return function(dispatch, getState){
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;}
         Util.post(Util.url+"/api/trade/monetaryFundBuyValidate",data,function(result){
            if (result.code=='0000') {
              dispatch(monetaryFundBuyRequest(data,callback))
            } else {
              Toast.info(result.message, Util.ToastTime );
            }
          },function(error){
            Toast.info(Util.errorTxt, Util.ToastTime );
          })
      },(m)=>{
          Toast.info(Util.errorTxt, Util.ToastTime );
      }))
    } ) .catch( (err)=>{ Toast.info(Util.errorTxt, Util.ToastTime ) } )
  }
}
//货币基金购买其他基金
export function monetaryFundBuyRequest(data,callback=()=>{}){
  return function(dispatch, getState){
    Util.post(Util.url+"/api/trade/monetaryFundBuyRequest",data,function(result){
      if (result.code=='0000') {
        callback(1,{content:{requestId:result.content}});
      } else {
        callback(3,result.message);
      }
    })
  }
}
//金额验证
export function rateAndFee(text){
  return {
    type:"RATE_AND_FEE",
    text:text
  }
}
export function getMoneyChange(data){
  if(data.applicationAmount.length==0){
    data.applicationAmount=0
  }
  return new Promise((resolve,reject)=>{
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/trade/queryRateAndFee",data,function(result){
        console.log(result);
        if (result.code=='0000') {
          resolve(result)
        }else{
          reject(result.code)
        }
      },function(error){
        reject(error)
      })
    }).catch( (error)=>{ reject(error) } )
  })
}
//转换
export function getDoConvert(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    console.log('-------------')
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;}
         Util.post(Util.url+"/api/trade/doConvert",data,function(result){
          if (result.code=='0000') {
            callback(1,result);
            Toast.hide();
          }else{
            callback(3);
            Toast.hide();
            Toast.info(result.message, Util.ToastTime );
          }
          },function(error){
            callback(3);
            Toast.hide();
            Toast.info( Util.errorTxt, Util.ToastTime );
          })
      },(m)=>{
          Toast.hide();
          Toast.info(m, Util.ToastTime );
      }))
     
    }).catch( (err)=>{ Toast.hide(); } )
  }
}
//赎回限额
export function getMinLimit(data,callback){
  return function(dispatch, getState){
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/trade/getMinLimit",data,function(result){
        if (result.code=='0000') {
          callback(result)
        }
        console.log(result,'赎回限额!!!')
      },function(error){

      })
    }).catch( (err)=>{ console.log(err) } )
  }
}
//赎回
export function getDoRedeem(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;}
        Util.post(Util.url+"/api/trade/doRedeem",data,function(result){
          if (result.code=='0000') {
            callback(1,result);
            Toast.hide();
          }else{
            callback(3);
            Toast.hide();
            Toast.info(result.message, Util.ToastTime );
          }
        },function(error){
          callback(3);
            Toast.hide();
            Toast.info( Util.errorTxt, Util.ToastTime );
        })
      },(m)=>{
        Toast.hide();
        Toast.info(m, Util.ToastTime );
      }))
    }).catch( (err)=>{ Toast.hide(); } )
  }
}
// Transformation
export function getTransformationFunList(fundCode,_this) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,
        fundCode:fundCode
      }
      Util.get(Util.url+"/api/trade/getCanConvertFundList",data,function(result){
        if (result.code=='0000') {
          
          console.log(result)
          Toast.hide();
          dispatch(TransformationFunList(result))
          _this.setState({
            listArr:result
          })
        } else{
          Toast.info(result.message,Util.ToastTime  );
        }
      },function(error){
        Toast.hide();
        console.log('jiekou error')
      })
    }).catch( (err)=>{ Toast.hide();} )
  }
}
export function TransformationFunList(text){
  return {
    type:"TRANSFORMATION_FUN_LIST",
    text:text
  }
}
//基金标签 - zbw
export function fundLabel(text){
  return {
    type:"FUND_LABEL",
    text:text
  }
}
//公募基金列表 - zbw
export function fundListGm(text){
  return {
    type:"FUND_LIST_GM",
    text:text
  }
}
//公募基金列表 - zbw
export function fundListGm2(text){
  return {
    type:"FUND_LIST_GM2",
    text:text
  }
}
//私募基金列表 - zbw
export function fundListSm(text){
  return {
    type:"FUND_LIST_SM",
    text:text
  }
}
//券商集合列表 - zbw
export function fundListJh(text){
  return {
    type:"FUND_LIST_JH",
    text:text
  }
}
//优选专户列表 - zbw
export function fundListZh(text){
  return {
    type:"FUND_LIST_ZH",
    text:text
  }
}
//基金筛选列表 - zbw
export function fundOperatingList(text){
  return {
    type:"FUND_OPERATING_LIST",
    text:text
  }
}
//基金搜索列表 - zbw
export function searchFundList(text){
  return {
    type:"SEARCH_FUND_LIST",
    text:text
  }
}

//获取基金标签
export function getFundLabel(params, zhType) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == "" || token == undefined || token == null || token == "9999"){
        params.token = "";
      }else {
        params.token = token;
      }
      Util.get(Util.url + "/Product/getLabelList", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          dispatch(fundLabel(data));
          if(params.fund_type == "G") {
            console.log("公募基金标签");
            dispatch(getFundListByPublic({type: 0}));
          }else if(params.fund_type == "S") {
            console.log("私募基金标签");
            dispatch(getFundListByPrivate({type: 0}));
          }else if(params.fund_type == "J") {
            if(zhType == "Z") {
              console.log("优选专户标签");
              dispatch(getFundListByAccount({type: 0}));
            }else {
              console.log("券商集合标签");
              dispatch(getFundListByBroker({type: 0}));
            }
          }
        }else {
          console.log(data.code);
          Toast.info(data.code, 2);
        }
      }, (err) => {
        Toast.info("错误信息" + err, 2);
        console.log("错误信息" + err);
      });
    });
  }
}

//获取公募基金列表 - zbw
export function getFundListByPublic(params) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == "" || token == undefined || token == null || token == "9999"){
        params.token = "";
      }else {
        params.token = token;
      }
      Util.get(Util.url + "/Product/getPublicPlacementList", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          dispatch(fundListGm(data));
          dispatch(fundListGm2(data));
          Toast.hide();
        }else {
          Toast.hide();
          console.log(data.code);
          Toast.info(data.code, 2);
        }
      }, (err) => {
        Toast.hide();
        Toast.info("错误信息" + err, 2);
        console.log("错误信息" + err);
      });
    });
  }
}

//获取私募基金列表
export function getFundListByPrivate(params) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == "" || token == undefined || token == null || token == "9999"){
        params.token = "";
      }else {
        params.token = token;
      }
      Util.get(Util.url + "/Product/getPrivateProductList", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          console.log("私募基金列表");
          dispatch(fundListSm(data));
          Toast.hide();
        }else {
          Toast.hide();
          console.log(data.code);
          Toast.info(data.code, 2);
        }
      }, (err) => {
        Toast.hide();
        console.log("错误信息" + err);
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

//获取券商集合列表 - zbw
export function getFundListByBroker(params) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == "" || token == undefined || token == null || token == "9999"){
        params.token = "";
      }else {
        params.token = token;
      }
      Util.get(Util.url + "/Product/getAggregateProductList", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          console.log("券商集合列表");
          dispatch(fundListJh(data));
          Toast.hide();
        }else {
          console.log(data.code);
          Toast.hide();
          Toast.info(data.code, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}


//获取优选专户列表
export function getFundListByAccount(params) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == "" || token == undefined || token == null || token == "9999"){
        params.token = "";
      }else {
        params.token = token;
      }
      Util.get(Util.url + "/Product/getSpecialDepositProductList", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          console.log("优选专户列表");
          dispatch(fundListZh(data));
          Toast.hide();
        }else {
          console.log(data.code);
          Toast.hide();
          Toast.info(data.code, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

//列表搜索 - zbw
export function getSearchFundList(params) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == "" || token == undefined || token == null || token == "9999"){
        params.token = "";
      }else {
        params.token = token;
      }
      Util.get(Util.url + "/Product/getAllProductList", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          console.log("列表搜索");
          dispatch(searchFundList(data));
          Toast.hide();
        }else {
          console.log(data.code);
          Toast.hide();
          Toast.info(data.code, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}








/*获取基金详情*/
export function fundPublicDetil(text){
  return {
    type:"FUND_PUBLIC_DETIL",
    text:text
  }
}

/*自选状态*/
export function AddZx(text){
  return{
    type:"Add_ZX",
    text:text
  }
}

/*获取公募基金详情*/
export function getPublicProductDetil(fundCode,callback,_this) {
  return function(dispatch, getState) {
    console.log('action');
    // dispatch(pageFlag(true));
    getTempInfo("shortToken")
    .then((token)=>{
      console.log('基金详情',Util.url + "/Product/getPublicProductDetil?fundcode=" + fundCode + "&token=" + token);
        fetch(Util.url + "/Product/getPublicProductDetil?fundcode=" + fundCode + "&token=" + token)
        .then((response) => response.json())
        .then((responseText) => {
          _this.setState({
            loadingFlag:false
          })

          if(responseText.code == "0000") {
            console.log("基金详情,action");
            console.log(responseText);
            dispatch(fundPublicDetil(responseText.content));
            dispatch(AddZx(responseText.content.is_optional));
            // dispatch(pageFlag(false));
            callback()

          }else{
            Toast.info( Util.errorTxt, Util.ToastTime );
          }
        })
        .catch(function(err){
          console.log("错误信息" + err);;
          _this.setState({
            loadingFlag:false
          })
        });
    })
    .catch( (err)=>{ console.log(err) } )
  }
}

/*私募基金详情*/
export function fundPrivateDetil(text){
  return {
    type:"FUND_PRIVATE_RATE",
    text:text
  }
}
/*获取私募详情*/
export function getPrivateProductDetil(id,callback,_this) {
  return function(dispatch, getState) {
    // dispatch(pageFlag(true))
    getTempInfo("shortToken").then((token) => {
      fetch(Util.url + "/Product/getPrivateProductDetil?fundcode=" + id + "&token=" + token)
        .then((response) => response.json())
        .then((responseText) => {
          _this.setState({
            loadingFlag:false
          })
          if(responseText.code == "0000") {
            console.log("基金详情");
            console.log(responseText);
            dispatch(fundPrivateDetil(responseText.content));
            dispatch(AddZx(responseText.content.is_optional));
            // dispatch(pageFlag(false));
            callback()
          }else{
    
            Toast.info( Util.errorTxt, Util.ToastTime );
          }
        })
        .catch(function(err){
          console.log("错误信息" + err);
          _this.setState({
            loadingFlag:false
          })
        });
    });
  }
}


/*集合理财详情*/
export function fundAggregateDetil(text){
  return{
    type:"FUND_AGGREGATE_RATE",
    text:text
  }
}
/*集合理财详情*/
export function getAggregateProductDetil(id,callback,_this) {
  return function(dispatch, getState) {
    // dispatch(pageFlag(true))
    getTempInfo("shortToken").then((token) => {
        console.log(token,"ssssssss",id);
        console.log(Util.url + "/Product/getAggregateProductDetil?fundcode=" + id + "&token=" + token)
        fetch(Util.url + "/Product/getAggregateProductDetil?fundcode=" + id + "&token=" + token)
        .then((response) => response.json())
        .then((responseText) => {
          _this.setState({
            loadingFlag:false
          })
          if(responseText.code == "0000") {
            console.log("集合理财详情基金详情");
            console.log(responseText);
            if(responseText.content != null){
              dispatch(fundAggregateDetil(responseText.content));
              responseText.content.is_optional == null ? dispatch(AddZx("0")) : dispatch(AddZx(responseText.content.is_optional));
              // dispatch(pageFlag(false));
              callback(responseText.content)
            }
          }else{
            Toast.info( Util.errorTxt, Util.ToastTime );
          }
        })
        .catch(function(err){
          console.log("错误信息" + err);
          _this.setState({
            loadingFlag:false
          })
        });
    });
  }
}


/*添加自选*/
export function reateOptional(data,callBack){
  return function(dispatch, getState) {
    getTempInfo("shortToken")
    .then( (token)=>{
      data.token = token;
      Util.get(Util.url+"/Product/createOptional",data,function(data){
        if(data.code == "0000"){
          dispatch(AddZx("1"));
          console.log("添加自选成功状态变为1")
          console.log(data.content)
          Toast.info("添加自选成功", Util.ToastTime );
          if(callBack){
            callBack()
          }
        }
      },function(error){
        console.log(error,333);
        Toast.info( Util.errorTxt, Util.ToastTime );
      })
    })
    .catch( (err)=>{ 
      console.log(err)

    } )

  }
}
/*取消自选*/
export function deleteOptional(data,callBack){
  return function(dispatch, getState) {
    getTempInfo("shortToken")
    .then( (token)=>{
      data.token = token;
      Util.get(Util.url+"/Product/deleteOptional",data,function(data){
        if(data.code == "0000"){
          dispatch(AddZx("0"));
          console.log(data.content)

          if(callBack){
            callBack()
          }
        }
      },function(error){
        console.log(error,333);

      })
    })
    .catch( (err)=>{
      
    })
  }
}

//基金历史净值
export function fundHistoryRate(text){
  return {
    type:"FUND_HISTORY_RATE",
    text:text
  }
}

/*私募历史净值*/
export function getHistoryProfileRate(data,callback){
  return function(dispatch, getState) {
    // dispatch(pageFlag(true))
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      Util.get(Util.url+"/Product/getHistoryRate",data,function(data){
        if(data.code == "0000"){
          dispatch(fundHistoryRate(data.content));
          callback(data.content);
          // dispatch(pageFlag(false))
        }
      },function(error){
        console.log(error,"历史净值");
        Toast.info(Util.errorTxt, Util.ToastTime );
      })
    });
  }
}

//文章详情
export function articleDetail(text){
  return {
    type:"ARTICLE_DETAIL",
    text:text
  }
}


export function getArticleDetail(data, callback) {
  return function(dispatch, getState) {
    Util.get(Util.url+"/api/article/getArticleDetail", data, (result) => {
      if(result.code == "0000") {
        dispatch(articleDetail(result.content));
        if(callback) {
          callback(result.content)
        }
        Toast.hide();
      }else {
        Toast.hide();
        Toast.info(result.message, Util.ToastTime );
      }
    }, (err) => {
      Toast.hide();
      Toast.info(Util.errorTxt, Util.ToastTime );
    });
  }
}

//点赞文章
export function editLikeArticle(data) {
  return function(dispatch, getState) {
    // Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/article/editArticleLike", data, (result) => {
        if(result.code == "0000") {
          // Toast.hide();
        }else {
          // Toast.hide();
          Toast.info(result.message, Util.ToastTime );
        }
      }, (err) => {
        // Toast.hide();
        Toast.info(Util.errorTxt, Util.ToastTime );
      });      
    }).catch( (err)=>{ Toast.hide(); Toast.info(Util.errorTxt, Util.ToastTime ); } )
  }
}

//留言列表
export function articleMessageList(text){
  return {
    type:"ARTICLE_MESSAGE_LIST",
    text:text
  }
}

export function getArticleMessageList(data, callback) {
  return function(dispatch, getState) {
    // Toast.loading('', 0);
    Util.get(Util.url+"/api/article/getArticleCommentList", data, (result) => {
      if(result.code == "0000") {
        dispatch(articleMessageList(result.content));
        callback(result.content)
      }else {
        Toast.info(result.message, Util.ToastTime );
      }
    }, (err) => {
      Toast.info(Util.errorTxt, Util.ToastTime );
    });      
  }
}

//写留言
export function writeArticleMessage(data, callback) {
  return function(dispatch, getState) {
    // Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/article/addUserComment", data, (result) => {
        if(result.code == "0000") {
          callback(result.content)
        }else {
          Toast.info(result.message, Util.ToastTime );
        }
      }, (err) => {
        Toast.info(Util.errorTxt, Util.ToastTime );
      });      
    }).catch( (err)=>{ Toast.hide(); Toast.info(Util.errorTxt, Util.ToastTime ); } )
  }
}

//点赞留言
export function editLikeMessage(data) {
  return function(dispatch, getState) {
    // Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/article/editCommentLike", data, (result) => {
        if(result.code == "0000") {
          // Toast.hide();
        }else {
          // Toast.hide();
          Toast.info(result.message, Util.ToastTime );
        }
      }, (err) => {
        // Toast.hide();
        Toast.info(Util.errorTxt, Util.ToastTime );
      });      
    }).catch( (err)=>{ Toast.hide(); Toast.info(Util.errorTxt, Util.ToastTime ); } )
  }
}

//获取用户风险问卷信息
export const getUserQuestionnaires = (data)=>{
  console.log(data,"dafafdf")
  return new Promise((resolve,reject)=>{
      Util.get(Util.url+"/api/account/getUserQuestionnaires",data,function(result){
          console.log(result,"用户当前问卷1111")
          if(result.code === '0000' && result.content){
           resolve(result.content.questionnaireNo) 
          }else{
            // let toast = Toast.show(result.code, getToastConfPoint( ) );
            resolve({})
          }
      },function(error){
          reject('1111')
      })
  })
}

//获取用户上次作答的问卷
export const queryLastAnswerQuestionnaire = (data)=>{
  console.log(data,"dafafdf")
  return new Promise((resolve,reject)=>{
      Util.get(Util.url+"/api/account/queryLastAnswerQuestionnaire",data, function(result){
            console.log(result,"用户之前问卷1111")
          if(result.code === '0000' && result.content){
           resolve(result.content) 
          }else{
            // let toast = Toast.show(result.code, getToastConfPoint( ) );
            resolve({})
          }
      },function(error){
          reject('1111')
      })
  })
}

//查询直销用户是否答过问卷
export const hasOtsRiskRearing = (params,callback)=>{
  return function(dispatch, getState) {
    console.log(params,"dafafdf")
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/account/hasOtsRiskRearing",params, async (result)=>{
          if(result.code === '0000'){
            // dispatch(syncCwimToCamc({}, () => {

            // }))
            if(result.content){
               callback("1","1",result.content) 
            }else{
              let wqInfoNow = await getUserQuestionnaires(params);
              let wqLast = await queryLastAnswerQuestionnaire(params);
              console.log(wqInfoNow,wqLast,result.content,"同步问卷条件")
              callback(wqInfoNow,wqLast,result.content) 
            } 
          }else{
              Toast.info(result.code, Util.ToastTime);
          }
      },function(error){
          Toast.info(Util.errorTxt, Util.ToastTime);
      })
    })
    .catch( (err)=>{
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);
    });
  }
}

/* 同步财富风险测评信息到直销 /api/camchqtaccount/syncCwimToCamc(新) */
export function syncCwimToCamcNew(params, callback) {
  return function(dispatch, getState) {
    // dispatch(pageFlag(true))
    Toast.loading();
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/v1/camchqtaccount/syncCwimRiskToCamc", params, function(responseText){   
        if(responseText.code == "0000"){
          Toast.hide();
          if(callback){
            callback(responseText.content);
          }
          console.log(responseText)
        }else{
          Toast.hide();
          console.log(responseText.message);
          Toast.info(responseText.message, Util.ToastTime);
          // dispatch(pageFlag(false));
        }
      }, function(err){
        Toast.hide();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);
        // dispatch(pageFlag(false));
      })
    })
    .catch( (err)=>{
      Toast.hide();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);
      // dispatch(pageFlag(false));
    });
  }
}
//更新直销风险等级并同步终止直销相关计划类交易
export function syncCwimRiskToCamcAndStopOutOfRiskBuyPlan(params, callback) {
  return function(dispatch, getState) {
    // dispatch(pageFlag(true))
    Toast.loading();
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/v1/camchqtaccount/syncCwimRiskToCamcAndStopOutOfRiskBuyPlan", params, function(responseText){   
        if(responseText.code == "0000"){
          Toast.hide();
          if(callback){
            callback();
          }
          console.log(responseText)
        }else{
          Toast.hide();
          console.log(responseText.message);
          Toast.info(responseText.message, Util.ToastTime);
          // dispatch(pageFlag(false));
        }
      }, function(err){
        Toast.hide();
        console.log(err)
        Toast.info(Util.errorTxt, Util.ToastTime);
        // dispatch(pageFlag(false));
      })
    })
    .catch( (err)=>{
      Toast.hide();
      console.log(err)
      Toast.info(Util.errorTxt, Util.ToastTime);
      // dispatch(pageFlag(false));
    });
  }
}
//组合申购限额
export function getSuperFundTradeLimit(params,callBack,errback) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then((data) => { 
      params.token = data;
      Util.get(Util.url+"/api/v1/superfund/trade/buy/getSuperFundTradeLimit",params,function(result){
        console.log(result)
        if (result.code=='0000') {
          callBack(result);
        }else{
          // errback(result);
          // Toast.info(result.message, Util.ToastTime);;
        }
      },function(error){
        // errback(error);
        // Toast.info(error, Util.ToastTime);
      })
    }).catch( (err)=>{ console.log(err) } )
  }
}

//赎回到活期通下单
export const getRedeemToHqtOk = (data,callback) => {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      Util.post(Util.url+"/api/trade/redeem2hqt",data,function(result){
          if (result.code=='0000') {
            callback(1,result);
          }else{
            callback(3,result.message);
          }
          Toast.hide();
      },function(error){
          callback(3,Util.errorTxt);
          Toast.hide();
          Toast.info(Util.errorTxt, Util.ToastTime);
      })
    }).catch( (err)=>{ console.log(err);Toast.hide(); } )
  }
}

//赎回到活期通预校验
export function getRedeemToHqtvalidate(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      dispatch(validateTransactionPassword(data,(c)=>{
         if (!c) {Toast.hide();Toast.info( '交易密码错误', Util.ToastTime );return;} 
        Util.post(Util.url+"/api/trade/redeem2hqt/validate",data,function(result){
          if (result.code=='0000') {
            dispatch(getRedeemToHqtOk(data,callback))
          }else {
            Toast.hide();
            Toast.info(result.message, Util.ToastTime);
          }
        },function(error){
          Toast.hide();
        })
      },(m)=>{
        Toast.hide();
        Toast.info(m, Util.ToastTime);
      }))
    }).catch( (err)=>{ console.log(err);Toast.hide(); } )
  }
}

//获取公募详情基金分析指标 近五年最大回撤
export  function getFundAnalysisIndicatorOfFiveYears(parameter,callback){
  return function(){
    Util.get(Util.url+"/api/product/publicFund/getFundAnalysisIndicatorOfFiveYears",parameter,(res)=>{
      console.log(res);
        if(res.code === "0000"){
          callback(res.content);
        }
    },(error)=>{
     Toast.show(Util.errorTxt, getToastConfPoint( ) );
    })
  }
}

//获取版本信息
export const getVersionInfo = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = (suc)=>{
			if(suc && suc.code === '0000'){
				console.log('获取版本信息成功');
				succallback(suc);
			}else{
				console.log('获取版本信息失败');
				errcallback(suc.message);
			}
		};
		const errorCallback = (err)=>{
			errcallback(Util.errorTxt);
		};
		Util.post(Util.url + '/api/upgrade/getVersion', params, successCallback, errorCallback);
	}
}

//新版公募详情折线图打点 
export function Newpublicinterfacedadian(params,callback){
  return function(dispatch, getState) {
      let data={
        fundCode:params.fundCode,
        fundPerformance:true,
        benchmarkPerformance:false,
        indexPerformance:false,
        type:'sincefound'
      }
      Util.get(Util.url+"/api/v1/product/publicFund/getLineChatVo",data,function(result){
        console.log(result)
        if(result.code == "0000"){
          callback(result.content);
        }else{
          Toast.info(result.message);
        }
      },function(error){
        Toast.info(Util.errorTxt );
      })
  }
}

//新版公募详情折线图
export function Newpublicinterface(params,callback){
  return function(dispatch, getState) {
    let data={
      fundCode:params.fundCode,
      type:params.type,
      symbolCode:params.symbolCode,
      fundPerformance:true,
      benchmarkPerformance:true,
    }
    Toast.loading()
    Util.get(Util.url+"/api/v1/product/publicFund/getLineChatVo",data,function(result){
      Toast.hide()
      if(result.code == "0000"){
        callback(result.content);
      }else{
        Toast.info(result.message);
      }
    },function(error){
      Toast.info(Util.errorTxt );
    })
  }
}

/*公募历史净值 可以分页 拿到最新日期数据*/
export function getPublicHistoryProfileRate(data,callback){
  console.log('2----');
  return function(dispatch, getState) {
    Util.get(Util.url+"/Product/publicFund/getHistoryRate",data,function(data){
      console.log(data);
      if(data.code == "0000"){
        dispatch(fundHistoryRatePage(data.content));
        callback(data.content);
      }else {
        Toast.show(data.message);
      }
    },function(error){
      console.log("错误信息" + error)
    })
  }
}

/*新版公募基金申购详情*/
export function newgetPublicProductDetil(fundCode,callback,_this) {
  return async function(dispatch, getState) {
      Toast.loading()
      fetch(Util.url + "/api/v2/product/publicFund/getPublicProductDetail?fundCode=" + fundCode,
      {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
      })
      .then((response) => response.json())
      .then((responseText) => {
        console.log('================',responseText);
        Toast.hide()
        if(responseText.code == "0000") {
          callback(responseText.content)
        }else{
          Toast.info(Util.errorTxt);
        }
      })
      .catch(function(err){
        console.log("错误信息" + err);;     
      }); 
  }
}


// WEBPACK FOOTER //
// ./src/action/productAction.js